import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Circular_Image from "../../assets/Circular_Image.png";
import Contact_Information from "../Contact_Information/Contact_Information";
import Image from "../../assets/Image.jpg";
import Line_Image from "../../assets/Line_Image.svg";
import Google_Play_Store_Scanner from "../../assets/About_Google_Play_Store_Scanner.svg";
import Play_Store_Button_Image from "../../assets/Play_Store_Button_Img.svg";
import App_Store_Button_Image from "../../assets/App_Store_Button_Img.svg";
import "./About.css";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [index, setIndex] = useState(0);
  const text = [
    "Hello!", //English
    "Namaskara!", //Kannada
    "Sat Sri Akaal!", //Punjabi
    "Namaste!", //Hindi
    "Vanakkam!", //Tamil
    "Namaskaram!", //Telugu
    "Nomoskar!", //Bengali
    "Namaskar!", //Marathi
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % text.length);
    }, 2000); // change every 3 seconds
    return () => clearInterval(interval);
  }, []);

  // const handlePlayStoreClick = () => {
  //   window.open(
  //     "https://play.google.com/store/apps/details?id=com.bolo.india",
  //     "_blank",
  //     "noopener,noreferrer",
  //   );
  // };
  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.bolo.india",
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleAppStoreClick = () => {
    window.open(
      "https://apps.apple.com/app/idXXXXXXXXX", // same App Store ID as Homepage_Card
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <>
      <Header />
      <div className="About_Us_Main">
        <div className="Sub_Contents_About_Us">
          <div className="Image">
            <img src={Image} alt="Image" />
          </div>
          <div className="Main_Div">
            <div className="About_Us_Content">
              <div className="Content">
                <h1 className="Text">{text[index]}</h1>
                <h2>Welcome to Bolo-India-Media</h2>
                <p>
                  We’re a bunch of Tech & Content geeks based in Bangalore,
                  creating a great space for we Indians to connect with each
                  other on everything that’s India. Taking cue from the thoughts
                  and words of our Honourable PM, we’re creating this for India,
                  Made in India, by Indians. Join us if you’re looking for a
                  heady mix of great tech, doing magic with data, great content
                  & media, and above all creating something incredible and
                  unique for India.
                </p>
              </div>
              <div className="Line_Image">
                {/* <img src={Line_Image} alt="Line_Image" />
                <h2>PASSION LED US HERE</h2>
                <p>
                  Connected from minds,
                  <br /> working from hearts.
                </p> */}

                <img
                  src={Google_Play_Store_Scanner}
                  alt="Google_Play_Store_Scanner"
                />
                <div className="About_Store_Buttons">
                  <div className="About_Play_Store_Button">
                    <button type="button" onClick={handlePlayStoreClick}>
                      <img
                        src={Play_Store_Button_Image}
                        alt="Play_Store_Button_Image"
                      />
                    </button>
                  </div>
                  {/* <div className="About_Play_Store_Button">
                    <button type="button" onClick={handleAppStoreClick}>
                      <img
                        src={App_Store_Button_Image}
                        alt="App_Store_Button_Image"
                      />
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="About_Asking">
            <h2>We would love to hear from you.</h2>
            {/* <p>
              We're on a recruitment spree! If you're a content creator,
              journalist, reporter, camera operator, data scientist, computer
              vision developer, an <br />
              AI genius, please talk to us.
            </p> */}

            {/* Mobile Screen */}
            {/* <p className="Para">
              We're on a recruitment spree! If you're a content creator,
              journalist, reporter, camera operator, data scientist, computer
              vision developer, an AI genius, please talk to us.
            </p> */}
          </div>

          <Contact_Information />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default About;
